export default __webpack_public_path__ + "static/media/pdfIcon.5f25f13b.svg";